<template>
  <path
    d="M21 3.00018H3C1.9 3.00018 1 3.90018 1 5.00018V19.0002C1 20.1002 1.9 21.0002 3 21.0002H21C22.1 21.0002 23 20.1002 23 19.0002V5.00018C23 3.90018 22.1 3.00018 21 3.00018ZM11 12.0002H4C3.45 12.0002 3 11.5502 3 11.0002V6.00018C3 5.45018 3.45 5.00018 4 5.00018H11C11.55 5.00018 12 5.45018 12 6.00018V11.0002C12 11.5502 11.55 12.0002 11 12.0002Z"
  />
</template>
